import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";
import Sidebar from "../components/Sidebar";
import TopBar from "../components/TopBar";
import Footer from "../components/Footer";

export default function DashboardLayout() {
  // Determine viewport tier on mount and on resize
  const [viewport, setViewport] = useState(() => {
    if (typeof window === "undefined") return "desktop";
    const w = window.innerWidth;
    if (w < 768) return "mobile";
    if (w < 1024) return "tablet";
    return "desktop";
  });

  // On desktop: persist user-controlled collapse preference
  // On tablet: always collapsed (icons only)
  // On mobile: drawer mode (overlay)
  const [desktopCollapsed, setDesktopCollapsed] = useState(() => {
    return localStorage.getItem("onpoint_sidebar_collapsed") === "true";
  });
  const [mobileOpen, setMobileOpen] = useState(false);

  useEffect(() => {
    const onResize = () => {
      const w = window.innerWidth;
      const next = w < 768 ? "mobile" : w < 1024 ? "tablet" : "desktop";
      setViewport(next);
      if (next !== "mobile") setMobileOpen(false);
    };
    window.addEventListener("resize", onResize);
    return () => window.removeEventListener("resize", onResize);
  }, []);

  useEffect(() => {
    localStorage.setItem("onpoint_sidebar_collapsed", desktopCollapsed);
  }, [desktopCollapsed]);

  const collapsed = viewport === "desktop" ? desktopCollapsed : viewport === "tablet" ? true : false;
  const sidebarWidth = viewport === "mobile" ? 0 : (collapsed ? 72 : 240);

  return (
    <div className="app-shell flex" style={{ minHeight: "100vh", backgroundColor: "#F7F8FA" }}>
      <Sidebar
        collapsed={collapsed}
        setCollapsed={setDesktopCollapsed}
        viewport={viewport}
        mobileOpen={mobileOpen}
        setMobileOpen={setMobileOpen}
      />

      <div
        className="app-main flex-1 flex flex-col min-w-0 transition-all duration-300"
        style={{ marginLeft: sidebarWidth, minHeight: "100vh" }}
      >
        <TopBar onOpenSidebar={() => setMobileOpen(true)} viewport={viewport} />
        <main className="app-main-content flex-1 p-2.5 lg:p-3.5">
          <Outlet />
        </main>
        <div className="app-main-footer" style={{ marginTop: "auto" }}>
          <Footer />
        </div>
      </div>
    </div>
  );
}
